import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import {
  EDITABLE_REFERENCES_ADD_ID_TO_SECTION,
  EDITABLE_REFERENCES_INITIAL_LOAD,
  EDITABLE_REFERENCES_REMOVE_ID_TO_SECTION,
  EDITABLE_REFERENCES_SET_AS_SECTION,
  PROFESSIONAL_REFERENCES_FORM,
  PROFESSIONAL_REFERENCES_LISTING,
  REFERENCE_LISTING_LOADED,
  REFERENCE_LOADED,
  REFERENCE_SAVE_PORTFOLIO,
  REFERENCE_UPDATED,
  REFERENCES_SECTION_ITEM_TO_ADD
} from '../../actions/resume'

const initialCreationForm = {
  title: ''
}
const initialDocumentFormatSelectionForm = {
  formattingId: null
}
const initialState = {
  formats: [],
  referencelist: {}
}
const initialProfessionalReferenceForm = {
  title: '',
  relationship: '',
  contact: '',
  position: '',
  company: '',
  phone: '',
  email: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
  notes: ''
}
const editableReferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFERENCES_SECTION_ITEM_TO_ADD:
      console.log(state, action)
      const newState3 = {
        ...state,
        [action.sectionKey]: [
          ...state[action.sectionKey]?.filter(f => f.id != action.item?.id),
          action.item
        ]
      }

      console.log('ADDING:', action, state, newState3)

      return newState3
    case EDITABLE_REFERENCES_INITIAL_LOAD:
      const newState = {
        ...state,
        ...action.parts
      }

      return newState
    case EDITABLE_REFERENCES_SET_AS_SECTION:
      return {
        ...state,
        referencelist: {
          ...state.referencelist,
          [action.sectionKey]: action.itemId
        }
      }
    case EDITABLE_REFERENCES_ADD_ID_TO_SECTION:
      if (state.referencelist[action.sectionKey]?.includes(action.itemId)) {
        return state
      }

      return {
        ...state,
        referencelist: {
          ...state.letter,
          [action.sectionKey]: [...state.referencelist[action.sectionKey], action.itemId]
        }
      }
    case EDITABLE_REFERENCES_REMOVE_ID_TO_SECTION:
      const newState2 = {
        ...state,
        referencelist: {
          ...state.referencelist,
          [action.sectionKey]: state.referencelist[action.sectionKey].filter(
            i => i != action.itemId
          )
        }
      }

      return newState2
    default:
      return state
  }
}
const reducers = combineReducers({
  referenceListingRequest: h2Api.restReducer(REFERENCE_LISTING_LOADED),
  referenceRenameRequest: h2Api.restReducer(REFERENCE_UPDATED),
  referenceRequest: h2Api.restReducer(REFERENCE_LOADED),
  creationFormRequest: h2Api.restReducer(),
  referenceSavePortfolioRequest: h2Api.restReducer(REFERENCE_SAVE_PORTFOLIO),
  professionalReferenceListingRequest: h2Api.restReducer(PROFESSIONAL_REFERENCES_LISTING),
  professionalReferenceFormRequest: h2Api.restReducer(PROFESSIONAL_REFERENCES_FORM),
  editableReferencesReducer,
  createForm: modelReducer('jobtools.reference.createForm', initialCreationForm),
  documentFormatSelectionForm: modelReducer(
    'jobtools.reference.documentFormatSelectionForm',
    initialDocumentFormatSelectionForm
  ),
  professionalReferenceForm: modelReducer(
    'jobtools.reference.professionalReferenceForm',
    initialProfessionalReferenceForm
  ),
  renameReferencesForm: modelReducer(
    'jobtools.reference.renameReferencesForm',
    initialCreationForm
  ),
  forms: formReducer('jobtools.reference', {
    renameReferencesForm: initialCreationForm,
    createForm: initialCreationForm,
    documentFormatSelectionForm: initialDocumentFormatSelectionForm,
    professionalReferenceForm: initialProfessionalReferenceForm
  })
})

export default reducers
